import Vue from 'vue'
import { settings } from './variables.js'
import axios from 'axios'

import ContactForm from './vue_components/ContactForm.vue'
import ContactFormPage from './vue_components/ContactFormPage.vue'
import QuestionForm from './vue_components/QuestionForm.vue'

import CallmeForm from './vue_components/CallmeForm.vue'

import CallmeFormInline from './vue_components/CallmeFormInline.vue'
import CallmeFormField from './vue_components/CallmeFormField.vue'
import CallmeFormHorizontally from './vue_components/CallmeFormHorizontally.vue'
import FaqForm from './vue_components/FaqForm.vue'

import RegionSelect from './vue_components/RegionSelect.vue'

import Ancet from './vue_components/ancet/Ancet.vue'


Vue.config.productionTip = false
axios.defaults.baseURL = settings.apiBaseUrl
axios.defaults.withCredentials = true 
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

Vue.prototype.$axios=axios


var vm = new Vue({
  el: '#app',
  components: {
  	'contactform': ContactForm,
    'ContactFormPage': ContactFormPage,
    'questionform': QuestionForm,
    'callmeform': CallmeForm,
    'callmeforminline': CallmeFormInline,
    'callmeformfield': CallmeFormField,
    'faqform': FaqForm,
    'CallmeFormHorizontally': CallmeFormHorizontally,
    'RegionSelect': RegionSelect,
    'Ancet': Ancet
  },

  data: {
  }

})
